import React from "react";
import PartnerFormPage from "../components/partners/PartnerFormPage";

const PartnerCreate = () => <PartnerFormPage mode="create" />;

export default PartnerCreate;
